module.exports = __webpack_public_path__ + "img/PT160.32b8537c.svg";